import { endOfYear, startOfYear } from "date-fns";
import {
  IStatementsRequestQuery,
  StatementStatus
} from "../../../services/api/banking/statements/types";
import {
  StatementQuerySort,
  StatementsFilters
} from "../../../modules/Statements/routes/RouteStatements";

export const createRequest = (
  filters: StatementsFilters,
  type: string,
  sort?: StatementQuerySort
): IStatementsRequestQuery => {
  const filter = {
    status:
      type === StatementStatus.Archived
        ? StatementStatus.Archived
        : StatementStatus.Available,

    ...(type === StatementStatus.Archived
      ? {}
      : {
          startDate: { ">=": startOfYear(new Date(Number(type), 0)) },
          endDate: { "<=": endOfYear(new Date(Number(type), 0)) }
        }),
    internalAccountType: filters.accountType
      ? {
          in: Array.isArray(filters.accountType)
            ? filters.accountType
            : [filters.accountType]
        }
      : undefined
  };

  // return { filter, sort: sort || { endDate: "desc" } };
  return { filter };
};
